import { v4 as generateUuid } from 'uuid';

if ('crypto' in window && typeof window.crypto.randomUUID !== 'function') {
  window.crypto.randomUUID = () => {
    return generateUuid() as `${string}-${string}-${string}-${string}-${string}`;
  };
}
